module.exports = __webpack_public_path__ + "img/bmbLogo.c2992d5d.png";